/* @flow */

import type { PivotOccupancyModeFeature } from "./types";
import followLink from "nexia_mobile/models/followLink";

export default function PivotOccupancyMode(feature: PivotOccupancyModeFeature) {
  const setOccupancyOverrideAction = feature.actions.set_occupancy_override;

  this.setOccupancyOverride = (value) => {
    if (setOccupancyOverrideAction) {
      const options = {
        data: { value },
        fetchModelWhenDone: true,
      };
      return followLink(this, setOccupancyOverrideAction, options);
    } else {
      return Promise.reject(
        new Error(
          "Attempted to set occupancy override on a device with no set occupancy override action"
        )
      );
    }
  };
  /* eslint-disable camelcase */
  return {
    pivotOccupancyMode: {
      name: feature.name,
      label: feature.label,
      options: feature.options,
      value: feature.value,
      displayValue: feature.display_value,
    },
    override_mode: feature.setpoints_override.occupancy_override_mode,
    override_enabled: feature.occupancy_override.occupancy_override_enabled,
    occupancy_override_start_time:
      feature.occupancy_override.occupancy_override_start_time,
    occupancy_override_time: feature.occupancy_override.occupancy_override_time,
    current_time: feature.occupancy_override.current_time,
  };
  /* eslint-enable camelcase */
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/pivot_occupancy_mode.js